import React, { useEffect, useState } from "react";
import { apiFetch } from "../utils/api";
import BuscadorCatalogo, { coincideBusqueda } from "./BuscadorCatalogo";
import Cargando from "./Cargando";

function CatalogoSimple({ titulo, icono = "🏷️", color = "var(--tema-primario, #2f6690)", bg = "var(--tema-suave, #dceaf5)", endpoint, placeholder }) {
  const [items, setItems] = useState([]);
  const [nombre, setNombre] = useState("");
  const [editandoId, setEditandoId] = useState(null);
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");

  const cargar = () => {
    setCargando(true);
    apiFetch(endpoint)
      .then((data) => setItems(data || []))
      .catch((err) => setError(err.message))
      .finally(() => setCargando(false));
  };

  useEffect(cargar, [endpoint]);

  const guardar = async (e) => {
    e.preventDefault();
    setError("");
    if (!nombre.trim()) return;
    try {
      const url = editandoId ? `${endpoint}/${editandoId}` : endpoint;
      await apiFetch(url, { method: "POST", body: JSON.stringify({ nombre }) });
      setNombre("");
      setEditandoId(null);
      cargar();
    } catch (err) {
      setError(err.message);
    }
  };

  const editar = (item) => {
    setEditandoId(item.id);
    setNombre(item.nombre);
  };

  const cancelarEdicion = () => {
    setEditandoId(null);
    setNombre("");
  };

  const eliminar = async (id) => {
    if (!window.confirm("¿Eliminar este registro?")) return;
    try {
      await apiFetch(`${endpoint}/${id}/eliminar`, { method: "POST", body: JSON.stringify({}) });
      cargar();
    } catch (err) {
      setError(err.message);
    }
  };

  const visibles = items.filter((item) => coincideBusqueda(busqueda, [item.nombre]));

  return (
    <div style={styles.card}>
      <div style={styles.cardHeader}>
        <span style={{ ...styles.cardIcono, background: bg }}>{icono}</span>
        <div style={{ textAlign: "center" }}>
          <h3 style={{ margin: 0, fontSize: "1rem", color: "var(--tema-titulo, #0b3c60)" }}>{titulo}</h3>
          <p style={{ margin: "0.1rem 0 0", fontSize: "0.78rem", color: "#8993a1" }}>
            {items.length} registro{items.length === 1 ? "" : "s"}
          </p>
        </div>
      </div>

      <form onSubmit={guardar} style={styles.form}>
        <input
          type="text"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          placeholder={placeholder}
          style={styles.input}
        />
        <button type="submit" style={{ ...styles.botonAgregar, background: color }}>
          {editandoId ? "Guardar cambios" : "+ Agregar"}
        </button>
        {editandoId && (
          <button type="button" onClick={cancelarEdicion} style={styles.botonCancelar}>
            Cancelar
          </button>
        )}
      </form>

      {error && <p style={{ color: "#a3402f" }}>{error}</p>}

      {cargando ? (
        <Cargando compacto />
      ) : items.length === 0 ? (
        <p className="vacio-simple">Todavía no hay registros.</p>
      ) : (
        <>
        <BuscadorCatalogo
          valor={busqueda}
          onCambiar={setBusqueda}
          placeholder={`Buscar en ${titulo.toLowerCase()}…`}
          mostrados={visibles.length}
          total={items.length}
        />
        <div className="table-scroll" style={styles.tablaWrap}>
          <table style={styles.tabla}>
            <thead>
              <tr style={{ textAlign: "center", borderBottom: "1px solid #d3d9df" }}>
                <th style={{ ...styles.th, background: bg, color, textAlign: "left" }}>Nombre</th>
                <th style={{ ...styles.th, background: bg, color, width: 200 }}></th>
              </tr>
            </thead>
            <tbody>
              {visibles.map((item, i) => (
                <tr
                  key={item.id}
                  style={{
                    borderBottom: "1px solid #eef1f3",
                    background: editandoId === item.id ? bg : i % 2 === 1 ? "#fafbfc" : "transparent",
                  }}
                >
                  <td style={styles.td}>
                    <span style={{ ...styles.dot, background: color }} />
                    {item.nombre}
                  </td>
                  <td style={{ ...styles.td, width: 200 }}>
                    <div style={styles.accionesFila}>
                      <button onClick={() => editar(item)} style={styles.botonFila}>
                        ✏️ Editar
                      </button>
                      <button onClick={() => eliminar(item.id)} style={styles.botonFilaPeligro}>
                        🗑️ Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </>
      )}
    </div>
  );
}

const styles = {
  card: {
    border: "1px solid #e2e6ea",
    borderRadius: 14,
    padding: "1.1rem 1.2rem",
    background: "#fff",
    boxShadow: "0 1px 3px rgba(27,42,74,0.06)",
    maxWidth: 560,
    margin: "0 auto",
  },
  cardHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.4rem",
    marginBottom: "1rem",
  },
  cardIcono: {
    width: 34,
    height: 34,
    borderRadius: 9,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.1rem",
    flexShrink: 0,
  },
  form: { display: "flex", gap: "0.5rem", marginBottom: "1rem", flexWrap: "wrap" },
  input: {
    flex: 1,
    minWidth: 200,
    padding: "0.45rem 0.6rem",
    border: "1px solid #d3d9df",
    borderRadius: 6,
    fontFamily: "inherit",
    fontSize: "0.88rem",
  },
  botonAgregar: {
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "0.5rem 1rem",
    fontSize: "0.85rem",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  botonCancelar: {
    background: "#fff",
    color: "var(--tema-titulo, #0b3c60)",
    border: "1px solid #d3d9df",
    borderRadius: 8,
    padding: "0.5rem 1rem",
    fontSize: "0.85rem",
    fontWeight: 600,
    cursor: "pointer",
  },
  tablaWrap: { border: "1px solid #eef1f3", borderRadius: 10 },
  tabla: { width: "100%", borderCollapse: "collapse", fontSize: "0.9rem" },
  th: {
    padding: "0.55rem 0.5rem",
    background: "#eef1f3",
    border: "1px solid #d3d9df",
    fontSize: "0.78rem",
    fontWeight: 700,
    color: "var(--tema-titulo, #0b3c60)",
  },
  td: { padding: "0.5rem 0.6rem", textAlign: "left" },
  accionesFila: {
    display: "flex",
    gap: "0.4rem",
    justifyContent: "flex-end",
    flexWrap: "nowrap",
  },
  dot: {
    display: "inline-block",
    width: 8,
    height: 8,
    borderRadius: "50%",
    marginRight: "0.55rem",
  },
  botonFila: {
    border: "1px solid #d3d9df",
    background: "#fff",
    borderRadius: 6,
    padding: "0.28rem 0.5rem",
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "var(--tema-titulo, #0b3c60)",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  botonFilaPeligro: {
    border: "1px solid #f7ded9",
    background: "#fff",
    borderRadius: 6,
    padding: "0.28rem 0.5rem",
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#a3402f",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
};

export default CatalogoSimple;
